/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * 
 * @export
 * @interface NewStoreLocation
 */
export interface NewStoreLocation {
    /**
     * 
     * @type {string}
     * @memberof NewStoreLocation
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewStoreLocation
     */
    isPrimaryLocation?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof NewStoreLocation
     */
    address?: Address;
    /**
     * 
     * @type {number}
     * @memberof NewStoreLocation
     */
    courierId?: number;
    /**
     * Hex color code for visual identification (e.g. #FF5733)
     * @type {string}
     * @memberof NewStoreLocation
     */
    colorCode?: string | null;
    /**
     * Short identifier code for this store location (e.g. KGN, MOB)
     * @type {string}
     * @memberof NewStoreLocation
     */
    code?: string | null;
    /**
     * Latitude of the store, for the staff clock-in geofence
     * @type {number}
     * @memberof NewStoreLocation
     */
    latitude?: number | null;
    /**
     * Longitude of the store, for the staff clock-in geofence
     * @type {number}
     * @memberof NewStoreLocation
     */
    longitude?: number | null;
    /**
     * Radius in meters within which staff can clock in (default 100)
     * @type {number}
     * @memberof NewStoreLocation
     */
    clockInRadiusMeters?: number | null;
}

/**
 * Check if a given object implements the NewStoreLocation interface.
 */
export function instanceOfNewStoreLocation(value: object): value is NewStoreLocation {
    return true;
}

export function NewStoreLocationFromJSON(json: any): NewStoreLocation {
    return NewStoreLocationFromJSONTyped(json, false);
}

export function NewStoreLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewStoreLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'isPrimaryLocation': json['isPrimaryLocation'] == null ? undefined : json['isPrimaryLocation'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'colorCode': json['colorCode'] == null ? undefined : json['colorCode'],
        'code': json['code'] == null ? undefined : json['code'],
        'latitude': json['latitude'] == null ? undefined : Number(json['latitude']),
        'longitude': json['longitude'] == null ? undefined : Number(json['longitude']),
        'clockInRadiusMeters': json['clockInRadiusMeters'] == null ? undefined : Number(json['clockInRadiusMeters']),
    };
}

export function NewStoreLocationToJSON(json: any): NewStoreLocation {
    return NewStoreLocationToJSONTyped(json, false);
}

export function NewStoreLocationToJSONTyped(value?: NewStoreLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'isPrimaryLocation': value['isPrimaryLocation'],
        'address': AddressToJSON(value['address']),
        'courierId': value['courierId'],
        'colorCode': value['colorCode'],
        'code': value['code'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'clockInRadiusMeters': value['clockInRadiusMeters'],
    };
}

